import { NgModule }  from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AlmEditableModule } from 'ngx-widgets';
import { Autosize } from './../autosize/autosize.directive';
import { InlineInputComponent } from './inlineinput.component';


export class InlineInputModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ InlineInputComponent, Autosize ],
  imports: [ CommonModule, FormsModule, AlmEditableModule ],
  exports: [ InlineInputComponent ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
